"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var GetBlockModels_1 = require("@CommonFrontendBackend/BlockModels/GetBlockModels");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BlockTypes_1 = require("@CommonFrontendBackend/BlockModels/BlockTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var inversify_react_1 = require("inversify-react");
var styles = __importStar(require("./AgreementButton.css"));
var AcceptBlockStore_1 = __importDefault(require("Project/Modules/Accept/AcceptBlockStore"));
var AngularSyncStore_1 = require("@CommonFrontend/Utils/AngularSyncStore");
var DIProvider_1 = __importStar(require("@CommonFrontend/DIProvider/DIProvider"));
var inversify_1 = require("inversify");
var mobx_react_1 = require("mobx-react");
var AcceptPreviewEventEmitter_1 = require("../AcceptPreviewEventEmitter");
var array = new Array(6).fill(0);
var AddAgreementButton = function (_a) {
    var onClick = _a.onClick, isAgreementPickerOpen = _a.isAgreementPickerOpen, setIsAgreementPickerOpen = _a.setIsAgreementPickerOpen;
    return (react_1.default.createElement(kaleidoscope_1.AngularOverlayProvider, null,
        react_1.default.createElement(kaleidoscope_1.Popover, { caret: true, maxHeight: 500, isOpen: isAgreementPickerOpen, onChange: setIsAgreementPickerOpen, padding: "none", className: styles.popover, size: kaleidoscope_1.PopoverSize.Auto, autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small }, buttonProps),
                react_1.default.createElement(icons_1.Add, null),
                " Add Agreement")); } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "center", align: "center", paddingLeft: "l", paddingRight: "l", paddingTop: "l" },
                react_1.default.createElement(kaleidoscope_1.Heading, { level: "4" }, "Choose an agreement"),
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), className: styles.closeButton, onClick: function () { return setIsAgreementPickerOpen(false); } })),
            react_1.default.createElement("div", { className: styles.gridContainer }, array.map(function (ele, idx) { return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", key: idx },
                react_1.default.createElement(kaleidoscope_1.ButtonCard, { elevation: 0, onClick: onClick, "aria-labelledby": "saved-agreement-".concat(idx) },
                    react_1.default.createElement("div", { className: styles.image })),
                react_1.default.createElement(kaleidoscope_1.Text, { size: "s", strong: true, id: "saved-agreement-".concat(idx) }, "Blank Agreement"))); })))));
};
var AgreementOptionsMenu = (0, mobx_react_1.observer)(function (_a) {
    var onClickDelete = _a.onClickDelete, openAgreementPicker = _a.openAgreementPicker;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xxs", padding: "xxs" },
        react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, type: kaleidoscope_1.ButtonType.Tertiary, className: styles.menuButton, onClick: function () {
                onClickDelete();
                openAgreementPicker();
            } },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
                react_1.default.createElement(icons_1.Swap, { size: icons_1.IconSize.Medium, className: styles.icon }),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.menuButtonText }, "Change agreement"))),
        react_1.default.createElement(kaleidoscope_1.Button, { isDestructive: true, type: kaleidoscope_1.ButtonType.Tertiary, className: styles.menuButton, onClick: onClickDelete },
            react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
                react_1.default.createElement(icons_1.Delete, { size: icons_1.IconSize.Medium, className: styles.icon }),
                react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s", className: styles.menuButtonText }, "Delete agreement")))));
});
var AgreementConfirmDelete = function (_a) {
    var onConfirm = _a.onConfirm, onCancel = _a.onCancel;
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", padding: "m" },
        react_1.default.createElement(kaleidoscope_1.Text, { strong: true, size: "s" }, "Delete agreement"),
        react_1.default.createElement(kaleidoscope_1.Text, { size: "s" }, "Remove this agreement permanently from this Qwilr page?"),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
            react_1.default.createElement(kaleidoscope_1.Button, { type: kaleidoscope_1.ButtonType.Secondary, size: kaleidoscope_1.ButtonSize.Small, onClick: onCancel }, "Cancel"),
            react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, isDestructive: true, onClick: onConfirm }, "Delete"))));
};
var EditAgreementButton = (0, mobx_react_1.observer)(function (_a) {
    var openAgreementPicker = _a.openAgreementPicker;
    var acceptBlockStore = (0, inversify_react_1.useInjection)(AcceptBlockStore_1.default);
    var deleteBlock = (0, inversify_react_1.useInjection)("deleteBlock");
    var notifyUser = (0, inversify_react_1.useInjection)("notifyUser");
    var blockCreator = (0, inversify_react_1.useInjection)("blockCreator");
    var blockFetcher = (0, inversify_react_1.useInjection)("blockFetcher");
    var projectStore = (0, inversify_react_1.useInjection)("projectStore");
    var acceptPreviewEventEmitter = (0, inversify_react_1.useInjection)("acceptPreviewEventEmitter");
    var agreementBlockRef = (0, react_1.useRef)(null);
    var _b = __read((0, react_1.useState)("options"), 2), screen = _b[0], setScreen = _b[1];
    return (react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", justify: "center" },
        react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary, onClick: function () {
                acceptPreviewEventEmitter.trigger(AcceptPreviewEventEmitter_1.AcceptPreviewEvent.OpenPreview);
            } },
            react_1.default.createElement(icons_1.Edit, null),
            "Edit agreement"),
        react_1.default.createElement("div", { className: styles.divider }),
        react_1.default.createElement(kaleidoscope_1.Popover, { padding: "none", size: kaleidoscope_1.PopoverSize.Small, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.Small, isIconOnly: true }, buttonProps),
                react_1.default.createElement(icons_1.OptionsHorizontal, null))); } }, screen === "options" ? (react_1.default.createElement(AgreementOptionsMenu, { onClickDelete: function () { return setScreen("confirmDelete"); }, openAgreementPicker: openAgreementPicker })) : (react_1.default.createElement(AgreementConfirmDelete, { onConfirm: function () { return __awaiter(void 0, void 0, void 0, function () {
                var block, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!acceptBlockStore.agreementId) {
                                return [2];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4, blockFetcher.fetchBlockById(projectStore._id, acceptBlockStore.agreementId)];
                        case 2:
                            block = _a.sent();
                            if (block.type === BlockTypes_1.BlockType.Agreement) {
                                agreementBlockRef.current = block;
                            }
                            return [3, 4];
                        case 3:
                            error_1 = _a.sent();
                            console.error("Error fetching agreement block:", error_1);
                            return [3, 4];
                        case 4: return [4, deleteBlock({ type: BlockTypes_1.BlockType.Agreement, _id: acceptBlockStore.agreementId })];
                        case 5:
                            _a.sent();
                            acceptBlockStore.agreementId = null;
                            notifyUser.success(react_1.default.createElement(react_1.default.Fragment, null,
                                "Agreement deleted",
                                " ",
                                react_1.default.createElement(kaleidoscope_1.Button, { onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
                                        var clonedBlockId;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    if (!acceptBlockStore.agreementId) return [3, 2];
                                                    return [4, deleteBlock({ type: BlockTypes_1.BlockType.Agreement, _id: acceptBlockStore.agreementId })];
                                                case 1:
                                                    _a.sent();
                                                    acceptBlockStore.agreementId = null;
                                                    _a.label = 2;
                                                case 2:
                                                    if (!agreementBlockRef.current) return [3, 4];
                                                    return [4, blockCreator.cloneBlock(agreementBlockRef.current)];
                                                case 3:
                                                    clonedBlockId = _a.sent();
                                                    acceptBlockStore.agreementId = clonedBlockId;
                                                    agreementBlockRef.current = null;
                                                    _a.label = 4;
                                                case 4: return [2];
                                            }
                                        });
                                    }); } }, "Undo")));
                            setScreen("options");
                            return [2];
                    }
                });
            }); }, onCancel: function () { return setScreen("options"); } })))));
});
var AgreementViewButtonComponent = (0, mobx_react_1.observer)(function () {
    var blockList = (0, inversify_react_1.useInjection)("blockList");
    var acceptBlockStore = (0, inversify_react_1.useInjection)(AcceptBlockStore_1.default);
    var _a = __read((0, react_1.useState)(false), 2), isAgreementPickerOpen = _a[0], setIsAgreementPickerOpen = _a[1];
    var blockModel = (0, GetBlockModels_1.getBlockModel)(BlockTypes_1.BlockType.Agreement);
    return (react_1.default.createElement(kaleidoscope_1.Stack, { className: styles.container }, !!acceptBlockStore.agreementId ? (react_1.default.createElement(EditAgreementButton, { openAgreementPicker: function () { return setIsAgreementPickerOpen(true); } })) : (react_1.default.createElement(AddAgreementButton, { isAgreementPickerOpen: isAgreementPickerOpen, setIsAgreementPickerOpen: setIsAgreementPickerOpen, onClick: function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4, blockList.create(blockModel)];
                    case 1:
                        res = _a.sent();
                        if (res.data && res.data._id) {
                            acceptBlockStore.agreementId = res.data._id;
                        }
                        setIsAgreementPickerOpen(false);
                        return [3, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error(error_2.message);
                        return [3, 3];
                    case 3: return [2];
                }
            });
        }); } }))));
});
var AgreementViewButton = (function () {
    function AgreementViewButton(createUi, mountReactComponent, di, $timeout) {
        this.ui = createUi(require("Project/Modules/Accept/Controls/Agreement/AgreementButton.html"), {
            $init: function (scope) {
                scope.ui.agreementButton = mountReactComponent(react_1.default.createElement(DIProvider_1.RootDIProvider, { di: di },
                    react_1.default.createElement(DIProvider_1.default, { container: function () {
                            var container = new inversify_1.Container({ skipBaseClassChecks: true });
                            container.bind(AngularSyncStore_1.AngularSyncServices.$).toConstantValue({ $scope: scope, $timeout: $timeout });
                            container.bind(AcceptBlockStore_1.default).toSelf().inSingletonScope();
                            return container;
                        } },
                        react_1.default.createElement(AgreementViewButtonComponent, null))));
            },
        });
    }
    return AgreementViewButton;
}());
exports.default = AgreementViewButton;
